import params from "./params";
import { postEditableRects } from "./postmessage";

// Marks a clickable/editable element for the interactive editor embed
// (host app iframe/WebView loaded with view=preview). Spread the result
// onto the element that carries the editing onClick:
//
//   <Heading.H2 tac {...editable(question)} onClick={() => postMessage(question)}>
//
// Only view=preview gets the markers — the print/printPreview/review DOM
// (the PDF/export path) is left byte-identical — and the hover styles that
// target .editable are additionally gated behind @media (hover: hover) in
// the global stylesheet, so touch devices and native WebViews never show
// them.
export default function editable(question) {
  if (params?.view !== "preview" || !question?.id) return {};
  return {
    className: "editable",
    "data-editable-id": question.id,
    "data-editable-type": question.type
  };
}

// Responds to the host's {type: "measure-editables"} request with the rect
// of every editable element on the page, in this frame's own coordinate
// space. Follows the coachmark-measure/coachmark-rect implementation style.
export function measureEditables() {
  const nodes = document.querySelectorAll("[data-editable-id]");
  const items = Array.from(nodes).map((el) => {
    const r = el.getBoundingClientRect();
    return {
      id: el.getAttribute("data-editable-id"),
      type: el.getAttribute("data-editable-type"),
      rect: {
        x: r.left,
        y: r.top,
        width: r.width,
        height: r.height
      }
    };
  });
  postEditableRects(items);
}
